/** Matches MafiaKillInitiator.BackfirePolicy */
export enum BackfireMode {
  None = 0,
  /** Fixed — shoot a chosen bullet amount */
  Range = 1,
  /** TwoX — 2× attacker bullets */
  DoubleAttacker = 2,
  /** Random — admin-configured global range */
  RangeRandom = 3,
  /** Same — match attacker bullets */
  SameAsAttacker = 4,
}

export const BACKFIRE_MIN_BULLETS = 1;
export const BACKFIRE_MAX_BULLETS = 75_000;
export const BACKFIRE_DEFAULT_MODE = BackfireMode.None;
export const BACKFIRE_DEFAULT_BULLET_AMOUNT = 1000;

export const BACKFIRE_STORAGE_KEY = "mafia_backfire_settings";

export interface BackfireSettings {
  mode: BackfireMode;
  rangeMin: number;
  rangeMax: number;
}

export const DEFAULT_BACKFIRE_SETTINGS: BackfireSettings = {
  mode: BACKFIRE_DEFAULT_MODE,
  rangeMin: BACKFIRE_DEFAULT_BULLET_AMOUNT,
  rangeMax: BACKFIRE_DEFAULT_BULLET_AMOUNT,
};

export interface BackfireOptionDefinition {
  id: BackfireMode;
  title: string;
  description: string;
  requiresBulletAmount: boolean;
}

export const BACKFIRE_OPTIONS: BackfireOptionDefinition[] = [
  {
    id: BackfireMode.Range,
    title: "Shoot X amount of bullets (Range)",
    description:
      "Return fire with a fixed bullet amount you choose (1–75,000).",
    requiresBulletAmount: true,
  },
  {
    id: BackfireMode.DoubleAttacker,
    title: "Shoot 2× amount of the attacker",
    description:
      "Automatically shoot back with twice the bullets your attacker spent.",
    requiresBulletAmount: false,
  },
  {
    id: BackfireMode.RangeRandom,
    title: "Shoot a random amount of the range",
    description:
      "Return fire with a random bullet count within the admin-configured game range.",
    requiresBulletAmount: false,
  },
  {
    id: BackfireMode.SameAsAttacker,
    title: "Shoot same amount",
    description:
      "Match the attacker bullet for bullet when you return fire.",
    requiresBulletAmount: false,
  },
  {
    id: BackfireMode.None,
    title: "No backfire",
    description: "Do not automatically return fire when you are attacked.",
    requiresBulletAmount: false,
  },
];

export const backfireModeRequiresBulletAmount = (mode: BackfireMode): boolean =>
  mode === BackfireMode.Range;
